import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
// import twitterImg from '../../../Assets/Images/Social/twitter.svg';
import MediaQuery from 'react-responsive';
import githubImg from '../../../Assets/Images/Social/git.svg';
import mailImg from '../../../Assets/Images/Social/mail.svg';
import instaImg from '../../../Assets/Images/Social/insta.svg';
// import dribbbleImg from '../../../Assets/Images/Social/dribbble.svg';
import linkedInImg from '../../../Assets/Images/Social/linkedin.svg';
import SocialLogo from './SocialLogo';
import device from '../../../Assets/Responsive/breakpoints';
import contact from '../../../Assets/Gif/contact2.gif';
import projects from '../../../Assets/consts';

const Container = styled.section`
  height: 80vh; /* Since pageSplitTime is 1.4 */
  width: 100%;
  /* border: 1px solid blue; */
  position: relative;
  overflow: hidden;
`;

const ContactTitle = styled.div.attrs({
  style: ({ scrollPercent }) => ({
    transform: `translateX(${scrollPercent * 8}%)`
  })
})`
  transition: transform 0.5s ease-out;
  font-family: 'AvenirHeavy';
  font-size: 200px;
  position: absolute;
  color: #eee;
  top: 12%;
  left: -70%;
  @media ${device.mobileMaxWidth} {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
    transform: none !important;
    left: 0%;
    right: 0%;
    width: 100%;
    text-align: center;
    font-size: 60px;
  }
`;
const Img = styled.img`
  border-radius: 50%;
  width: 97px;
  height: 102px;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 78px;
  left: 172px;
  @media ${device.mobileMaxWidth} {
    display: none;
  }
`;
const SocialMediaIcons = styled.div`
  /* border: 1px solid black; */
  margin-left: 20%;
  margin-right: 3%;
  z-index: 1;
  transform: translateY(210%);
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  @media ${device.mobileMaxWidth} {
    margin-left: 0%;
    margin-right: 0%;
  }
`;
const ScrollDownLink = styled.a`
  position: absolute;
  bottom: 20px;
  right: 50%;
  z-index: 2;
  display: inline-block;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  transform: rotate(180deg);
  font: normal 400 20px/1 'Josefin Sans', sans-serif;
  letter-spacing: 0.1em;
  text-decoration: none;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.5;
  }
`;
const arrowAnimatation = keyframes`
0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const ArrowSpan = styled.span`
  position: absolute;
  top: 0;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 2px solid black;
  border-bottom: 2px solid black;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: ${arrowAnimatation} 2s infinite;
  animation: ${arrowAnimatation} 2s infinite;
  opacity: 0;
  box-sizing: border-box;
  &:nth-of-type(1) {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
  }
  &:nth-of-type(2) {
    top: 16px;
    -webkit-animation-delay: 0.15s;
    animation-delay: 0.15s;
  }
  &:nth-of-type(3) {
    top: 32px;
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
`;
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: 0,
      scrollHeight: 0,
      scrollPercent: 0
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState({
      scrollHeight: Math.round(window.document.documentElement.scrollHeight)
    });
    this.setState({
      screenHeight: Math.round(window.document.documentElement.clientHeight)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const sd = Math.max(body.scrollTop, documentElement.scrollTop);
    let sp = (sd / (documentElement.scrollHeight - documentElement.clientHeight)) * 100;
    const minlimit = (documentElement.clientHeight * projects.contactTitleMinLimit) / documentElement.scrollHeight;
    if (sp >= minlimit && sp <= 100) {
      sp -= minlimit;
      this.setState({ scrollPercent: sp });
    }
  }

  render() {
    const { scrollPercent } = this.state;

    // console.log(scrollHeight);
    return (
      <Container>
        <ContactTitle scrollPercent={scrollPercent}>
          CONTACT
          <Img src={contact} alt="contact" />
        </ContactTitle>

        <SocialMediaIcons>
          {/* <SocialLogo imgURL={twitterImg} alternate="Twitter" redirectURL="https://twitter.com/dorbellmas" /> */}
          <SocialLogo imgURL={instaImg} alternate="Instagram" redirectURL="https://www.instagram.com/dorbellmas/" />
          <SocialLogo imgURL={githubImg} alternate="Github" redirectURL="https://github.com/dorbalmas" />
          <SocialLogo imgURL={mailImg} alternate="Mail" redirectURL="mailto:dorbal31@gmail.com" />
          <SocialLogo imgURL={linkedInImg} alternate="Linkedin" redirectURL="https://www.linkedin.com/in/dor-bellmas" />
        </SocialMediaIcons>
        <MediaQuery query="(min-device-width: 1224px)">
          <ScrollDownLink href="#about">
            <ArrowSpan />
            <ArrowSpan />
            <ArrowSpan />
          </ScrollDownLink>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          <ScrollDownLink href="#home">
            <ArrowSpan />
            <ArrowSpan />
            <ArrowSpan />
          </ScrollDownLink>
        </MediaQuery>
      </Container>
    );
  }
}

export default Contact;
